import React from 'react';

/**
 * Wrapper compatto per i filtri con etichetta a lato (non sopra), pensato per
 * barre di filtri orizzontali (Macchine/Articoli/Compatibilità).
 */
export function FilterField({ label, className = '', children }: {
  label: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-[13px] font-semibold text-[#5c5c57] whitespace-nowrap flex-none">{label}</span>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
